import { useQuery } from '@tanstack/react-query';
import { hangoutsService } from '../services/hangouts.service';

export const useCurrentHangout = () =>
    useQuery({
        queryKey: ['hangouts', 'current'],
        queryFn: () => hangoutsService.current(),
        // A hangout opens and closes rarely, but a stale "nothing running" is
        // the difference between betting and staring at an empty screen.
        staleTime: 30_000,
    });

export const useStandings = (hangoutId: number | undefined) =>
    useQuery({
        queryKey: ['hangouts', hangoutId, 'standings'],
        queryFn: () => hangoutsService.standings(hangoutId as number),
        enabled: hangoutId !== undefined,
        // Balances move whenever anyone settles a market, and this screen is
        // what people stare at while waiting for that.
        refetchInterval: 5_000,
        staleTime: 0,
    });

export const useMyEntry = (hangoutId: number | undefined) =>
    useQuery({
        queryKey: ['hangouts', hangoutId, 'me'],
        queryFn: () => hangoutsService.myEntry(hangoutId as number),
        enabled: hangoutId !== undefined,
        refetchInterval: 5_000,
        staleTime: 0,
        // A player who has not joined gets a 404, which is an answer rather
        // than a fault worth retrying.
        retry: false,
    });

export const useHangoutHistory = () =>
    useQuery({
        queryKey: ['hangouts', 'list'],
        queryFn: () => hangoutsService.list(),
        staleTime: 60_000,
    });

export const useHangoutResults = (hangoutId: number | undefined) =>
    useQuery({
        queryKey: ['hangouts', hangoutId, 'results'],
        queryFn: () => hangoutsService.results(hangoutId as number),
        enabled: hangoutId !== undefined,
        // A closed hangout's standings are frozen, so they never go stale.
        staleTime: Infinity,
    });

export const useAllTime = () =>
    useQuery({
        queryKey: ['hangouts', 'all-time'],
        queryFn: () => hangoutsService.allTime(),
        // Only changes when a hangout closes.
        staleTime: 5 * 60_000,
    });


